import * as React from 'react';
import Grade from './../components/Grades/Grade';
import Category from '../components/Category/Category';
import { makeStyles } from '@mui/styles';
import { useEffect, useRef } from 'react';
import { useQueryParam } from 'use-query-params';
import Header from '../components/Header/header';
import GreenHeader from '../components/Header/GreenHeader';

function myFunction(): boolean {
  // const header = document.getElementById('myHeader');
  // const sticky = header?.offsetTop ?? 0;
  if (window.pageYOffset > 150) {
    return true;
  } else {
    return false;
  }
}

const useStyles = makeStyles({
  sticky: {
    maxWidth: '1040px',
    marginBottom: '16px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '00px',
  },
  nonSticky: {
    padding: '10px',
    maxWidth: '1760px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

export default function Home() {
  const [category] = useQueryParam<string | undefined>('category');
  const [sticky, setSticky] = React.useState(false);
  const classes = useStyles();
  const ref = useRef<any>(null);
  useEffect(() => {
    const watchScroll = () => {
      window?.addEventListener('scroll', () => setSticky(myFunction()));
    };
    watchScroll();
    // Remove listener (like componentWillUnmount)
    return () => {
      window?.removeEventListener('scroll', () => setSticky(myFunction()));
    };
  }, []);

  return (
    <>
      <Header />
      <GreenHeader />

      {/* <div style={{ width: '100%', overflow: 'hidden' }}>*/}
      {/*  <img alt={''} src={'/3.jpg'} style={{ width: '116%', marginLeft: '-8%' }} />*/}
      {/* </div>*/}
      {/* <Banner />*/}
      <Category sticky={sticky} />
      <div className='content' style={{ marginTop: 20 }}>{category && <Grade />}</div>
      {/* <img alt={''} src={'/2.jpg'} style={{ width: '100%' }} />*/}
      {/* <img src={'/1.jpg'} style={{ width: '100%' }} />*/}
    </>
  );
}
